import { render, staticRenderFns } from "./StatisticsMarksTimeDepartmentView.vue?vue&type=template&id=2de7ab32"
import script from "./StatisticsMarksTimeDepartmentView.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksTimeDepartmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports